import { createGetAsyncSlice } from '@sonar-software/xuder';
import { getDataSecurityStatus } from '@api/data-security/getDataSecurityStatus';

export const getCoreDataSecurityStatusSlice = createGetAsyncSlice({
	name: 'CoreDataSecurityStatus',
	receive: true,
	request: false,
	requestHandler: getDataSecurityStatus,
	retainDataOnRequest: true
});
